import { PRESEVE_PREVIOUS_PRICE, SHOW_PAY_NOW_AMOUNT_WARNING } from "./constants";

export const SETTINGS = {
  MSA: {
    eow: "",
    dist_id_num: "",
    proj_id_num: "",
    test_or_live: "",
    interval: "",
    dist_name: "",
    dist_addr: "",
    dist_city: "",
    dist_state: "",
    dist_zipcode: "",
    dist_country: "",
    dist_cont_ln: "",
    dist_cont_fn: "",
    dist_cont_tel: "",
    dist_cont_fax: "",
    dist_cont_email: "",
    no_of_measured_bid: "",
    no_of_measured_sid: "",
    no_of_measured_pur: "",
    inv_resub_flag: "1",
  },

  Invoice: {
    order_details: {
      Invoice_no: true,
      Invoice_date: true,
      Order_type: true,
      Order_by: true,
      cashier_name: true,
      sale_agent_name: true,
      Order_date: true,
      Payment_type: true,
      Payment_date: true,
      AGING_TYPE: true,
      Due_date: true,
      invoice_promotion_banner_check: true,
      Status:true,
    },
    customer_details: {
      Business_name: true,
      Person_name: true,
      Phone: true,
      Email: true,
      Customer_balance: true,
      Shipping_type: true,
      Customer_number: true,
      show_customer_liscenses: true,
      show_resale_certificate:true,
      show_business_certificate:true,
      show_tobacco_certificate:true,
      state_id_licence:true,
      other_certificates:true
    },
    bill_to: {
      Bill_Business_name: true,
      Name: true,
      Email:true,
      Phone_no: true,
      Address: true,
      County: true,
      Country: true,
    },
    ship_to: {
      Ship_Business_name: true,
      Name: true,
      Email:true,
      Phone_no: true,
      Address: true,
      County: true,
      Country: true,
    },
    product_details: {
      Sr_No: true,
      Image: true,
      Name: true,
      SKU: true,
      UPC_Barcode: true,
      UPC_Number: true,
      Supply_Price: true,
      msrp_price: true,
      Discount: true,
      Taxes: true,
      Tax_notes: false,
      Unit: true,
      Qty: true,
      Extended: true,
      Total_Without_Discount: false,
      return_to_stock:true,


      // Theme2 keys
      Theme2Sr_No: true,
      Theme2Image: true,
      Theme2Name: true,
      Theme2Qty: true,
      Theme2Net_Sale_Price: true,
      Theme2Box_UPC_Number: true,
      Theme2Size: true,
      Theme2unit_price: true,
      Theme2Unit_UPC: true,
      Theme2return_to_stock: true,
      Theme2Taxes: true,
      Theme2Extended: true,
      Theme2SKU: true,
    },
    payment_detials: {
      Sr_No: true,
      Payment_Type: true,
      reference_no: true,
      Payment_ID: true,
      Payment_Date: true,
      Payment_Amount: true,
      Applied_Amount: true,
      Credit_Amount: true,
      Status: true,
      Payment_Terms: true,
    },
    total_amount_details: {
      Total_Products: true,
      Total_Quantity: true,
      Sub_Total: true,
      Returned_Quantity: true,
      Amount_Returned: true,
      Coupon_Discount: true,
      Other_Discount: true,
      Discount_Amount: true,
      Delivery_Charges: true,
      Tax: true,
      Total: true,
      On_Account: true,
      Paid_Amount: true,
      Previous_Balance: true,
      Show_tax_breakdown: true,
    },
  },

  Basic: {
    licence_expiry_threshold: "",
    tenant_invoice_details: "Your Company",
    account_title: "",
    website: "https://YourWebsite.com",
    logo: "https://khub-app.s3-accelerate.amazonaws.com/media/basic-settings/images/e325d1bd-a8a8-437b-90fd-9f446a81da11?cacheblock=true",
    forget_pass_subj: "",
    dashboard_logo: "",
    tenant_invoice_logo: "https://khub-app.s3-accelerate.amazonaws.com/media/basic-settings/images/e325d1bd-a8a8-437b-90fd-9f446a81da11?cacheblock=true",
    forget_pass_html: "",
    skip_eligibility_check: "",
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
    favicon: "https://yourfavicon.com",
    currency_symbol: "",
    currency_type: "",
    country_name: "",
    country_code: "",
    country_iso2: "",
    invoice_image: "",
    invoice_promotion_banner:"",
    timezone: {
      value: "America/Detroit",
      label: "(GMT-4:00) Eastern Time",
      offset: -4,
      abbrev: "EDT",
      altName: "Eastern Daylight Time",
    },
    ecom_styles_settings: {
      footer_title_color: '#ffffff',
      footer_title_size: '24',
      footer_title_font_family: '"Poppins", sans-serif',
      footer_text_color: '#B3B3B3',
      footer_text_size: '16',
      footer_text_font_family: '"Poppins", sans-serif',
      footer_background_color: 'rgba(26, 26, 26, 1)',
      heading_text_align:'center',
      nav_font_family: '"Montserrat", sans-serif',
      nav_font_size: '24',
      nav_text_color: '#555252',
      nav_text_color_hover: '#c51515',    
      nav_background: '#ffffff',    
    },
    ecom_styles_basic_settings: {
      ticker_tape_text_color: '#333333',
      ticker_tape_background: '#ffeb01',
      ticker_tape_text_size: '25',
      ticker_tape_font_family: '"Montserrat", sans-serif',

      about_us_background: '#ffffff',
      about_us_heading_size: '48',
      about_us_heading_family: '"Montserrat", sans-serif',
      about_us_heading_color: 'rgb(234, 30, 81)',
      about_us_text_color: 'rgb(128, 128, 128)',
      about_us_text_size: '18',
      about_us_text_family: '"Montserrat", sans-serif',

      about_us_statistics_background_color: "#ffffff",
      about_us_statistics_text_color: 'rgb(128, 128, 128)',
      about_us_statistics_text_size: '16',
      about_us_statistics_text_family: '"Montserrat", sans-serif',

      about_us_statistics_number_color: 'rgb(234, 30, 81)',
      about_us_statistics_number_size: '30',
      about_us_statistics_number_family: '"Montserrat", sans-serif',

      contact_us_background_color: '#ffffff',
      contact_us_heading_color: '#1A1A1A',
      contact_us_heading_size: '60',
      contact_us_heading_family: '"Montserrat", sans-serif',
      contact_us_form_background_color: '#ffffff',
      contact_us_form_text_color: '#000',
      contact_us_form_text_family: '"Montserrat", sans-serif',

      contact_us_information_background: 'rgb(234, 30, 81)',
      contact_us_information_text_color: '#ffffff',
      contact_us_information_text_family: '"Montserrat", sans-serif',
    }
  },
  IMMUTABLE_BASIC: {
    ecom_url: "",
    portal_url: "",
  },
  SALE_SETTING: {},
  POS: {
    tax_type: 1,
    tax: 5.0,
    COT: 5,
    delivery_charges: 200,
    enable_gateway_type: false,
    auto_apply_credit: true,
    apply_additional_discount_before_tax: true,
    [SHOW_PAY_NOW_AMOUNT_WARNING]: false,
    enable_terminal_type: "default",
    nmi_secret_key: "default",
    nmi_public_key: "default",
    econduit_terminal_id: "default",
    econduit_app_pass: "default",
    [PRESEVE_PREVIOUS_PRICE]:false,
    is_stripe_enabled: false,
    stripe_public_key: "default",
    stripe_secret_key: "default",
    attributes: [],
    payment_types: [
      {
        value: 3,
        type: "Credit/Debit Card",
        id: "control_03",
        name: "CREDIT_DEBIT_CARD",
        active: true,
      },
      {
        value: 5,
        type: "Zelle/Wire Transfer",
        id: "control_05",
        name: "ZELLE_WIRE_TRANSFER",
        active: true,
      },
      {
        value: 1,
        type: "Cash",
        id: "control_01",
        name: "CASH",
        active: true,
      },
      {
        value: 12,
        type: "ACH",
        id: "control_01",
        name: "ACH",
        active: true,
      },
      {
        value: 2,
        type: "Cheque",
        id: "control_02",
        name: "CHEQUE",
        active: true,
      },
      // {
      //   value: 4,
      //   type: "Cash On Delivery",
      //   id: "control_04",
      //   name: "CASH_ON_DELIVERY",
      //   active: true,
      // },
      {
        value: 6,
        type: "On Account/Cash On Delivery",
        id: "control_06",
        name: "ON_ACCOUNT",
        active: true,
      },
      {
        value: 7,
        type: "Money Order",
        id: "control_07",
        name: "Money Order",
        active: true,
      },
      {
        value: 9,
        type: "Wallet",
        id: "control_09",
        name: "Wallet",
        active: true,
      },
    ],
    order_types: [
      {
        value: 1,
        type: "Walk In",
        name: "WALK_IN",
      },
      {
        value: 2,
        type: "Phone",
        name: "PHONE",
      },
      {
        value: 3,
        type: "Online",
        name: "ONLINE",
      },
      {
        value: 4,
        type: "Offsite",
        name: "OFFSITE",
      },
      {
        value: 5,
        type: "Other",
        name: "OTHER",
      },
    ],
  },
  TAX: {
    tenant_tax_applicable: false
  },
  DELIVERY: {
    enable_delivery_module: false,
    address_verification: false,
    khub_terms_verification: false,
    driver_consent_record_acknowledgment: false,
  },
  SHIPPING: {
    default_warehouse: "",
    display_units: "imperial",
    parcel_available: true,
    ltl_available: true,
    ltl_weight_threshold: 150,
    default_billing: "prepaid",
  },
  type: "admin-panel",
};